import coverIllus from "../assets/illustrations/guide/structured-thinking/cover.svg";
import whyMattersIllus from "../assets/illustrations/guide/structured-thinking/why-matters.svg";
import whatIsIllus from "../assets/illustrations/guide/structured-thinking/what-is.svg";
import structureBeatsMotivationIllus from "../assets/illustrations/guide/structured-thinking/structure-beats-motivation.svg";
import eventVsInterpretationIllus from "../assets/illustrations/guide/structured-thinking/event-vs-interpretation.svg";
import evidenceIllus from "../assets/illustrations/guide/structured-thinking/evidence.svg";
import respondReactIllus from "../assets/illustrations/guide/structured-thinking/respond-react.svg";
import frameworksIllus from "../assets/illustrations/guide/structured-thinking/frameworks.svg";
import reflectionRuminationIllus from "../assets/illustrations/guide/structured-thinking/reflection-rumination.svg";
import eierIllus from "../assets/illustrations/guide/structured-thinking/eier.svg";
import finalThoughtsIllus from "../assets/illustrations/guide/structured-thinking/final-thoughts.svg";

export const STRUCTURED_THINKING_COVER = {
  banner: "Think with clarity",
  illustration: coverIllus,
  illustrationAlt: "Organized thought pathways leading to a clear decision",
};

export const STRUCTURED_THINKING_ACCENTS = ["amber", "electric", "fuchsia", "mint"];

export const STRUCTURED_THINKING_SECTION_VISUALS = {
  "why-structured-thinking-matters": {
    illustration: whyMattersIllus,
    illustrationAlt: "Scattered thoughts becoming an ordered path",
    banner: "Start here",
  },
  "what-is-structured-thinking": {
    illustration: whatIsIllus,
    illustrationAlt: "Roadmap with steps from event to response",
    banner: "The framework",
  },
  "why-structure-beats-motivation": {
    illustration: structureBeatsMotivationIllus,
    illustrationAlt: "Road structure supporting forward movement",
    banner: "Structure first",
  },
  "event-vs-interpretation": {
    illustration: eventVsInterpretationIllus,
    illustrationAlt: "Split view of a fact and a story about it",
    banner: "Facts vs. stories",
  },
  "evidence-based-thinking": {
    illustration: evidenceIllus,
    illustrationAlt: "Scales balancing facts and assumptions",
    banner: "Test assumptions",
  },
  "respond-vs-react": {
    illustration: respondReactIllus,
    illustrationAlt: "Pause between stimulus and intentional action",
    banner: "Choose your response",
  },
  "thinking-frameworks": {
    illustration: frameworksIllus,
    illustrationAlt: "Question marks guiding thought examination",
    banner: "Ask better questions",
  },
  "reflection-vs-rumination": {
    illustration: reflectionRuminationIllus,
    illustrationAlt: "Forward arrow versus a circular loop",
    banner: "Move forward",
  },
  "the-eier-framework": {
    illustration: eierIllus,
    illustrationAlt: "Four-step EIER process diagram",
    banner: "EIER in practice",
  },
  "final-thoughts": {
    illustration: finalThoughtsIllus,
    illustrationAlt: "Calm figure with clear thought lines",
    banner: "Choose clarity",
  },
};

export function getStructuredThinkingSectionVisual(sectionId) {
  return STRUCTURED_THINKING_SECTION_VISUALS[sectionId] || null;
}

export function getStructuredThinkingAccent(index) {
  return STRUCTURED_THINKING_ACCENTS[index % STRUCTURED_THINKING_ACCENTS.length];
}
